module.exports = __webpack_public_path__ + "img/shopping.62048372.jpg";